class restoreRsvp {
    constructor(Alert, $http, $state, $translate) {

        this.key = 'restore-rsvp';
        this.title = 'Restore';
        this.level = 'archived-highlight';
        this.icon = 'fal fa-undo';
        this.alert = Alert;
        this.api = $http;
        this.state = $state;
        this.translate = $translate;
    }

    action(rsvp, vm) {
        const translatedValue = (path, params) => {
            return this.translate.instant(`guestlists.workflows.ask-to-restore-rsvp.${path}`, params);
        };

        this.alert.animatedAlert(
            translatedValue('title'),
            translatedValue('content', {rsvp_name: rsvp.contact.data.full_name || rsvp.contact.data.first_name + ' ' + rsvp.contact.data.last_name}),
            'attention',
            {
                confirmButtonText: translatedValue('confirm'),
                cancelButtonText: translatedValue('cancel'),
                wait: true
            }).then(() => {
            return this.api.put(`guestlists/${ vm.guestlist.id }/rsvps/${ rsvp.id }/restore`)
                .then(() => {
                    this.state.reload();
                    if (vm.store) {
                        return vm.store.dispatch('getData');
                    }
                }, err => this.alert.handle(err));
        }, () => ({}))
    }

}

angular
    .module('festzelt-os.guestlists')
    .factory('restoreRsvp', [
        'Alert',
        '$http',
        '$state',
        '$translate',
        (Alert, $http, $state, $translate) => new restoreRsvp(Alert, $http, $state, $translate)
    ]);




// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/detailed/restore-rsvp.js